import moment from 'moment-timezone';
import {
    getNextAvailableConfigForTheDay,
    getDefaultNextAvailableConfig,
    saveNextAvailableConfig,
    addDrawsToFacilityAndDay,
    getDrawsForFacilityAndDay,
    getMatchesForFacilityAndDay,
    removeDrawFromFacilityAndDay,
    startDrawAddedToFacilityAndDay,
    getSummaryForFacilityAndDay,
    removeAllDrawsFromFacilityAndDay,
    scheduleMatch,
    startMatch,
    pauseMatch,
    postScore,
    unScheduleMatch,
    reScheduleMatch,
    publishDraws,
} from '../api/tmsEventsNextAvailableApi';
import {
    GET_NA_COURT_CONFIG_DATA,
    GET_NA_COURT_CONFIG_DATA_SUCCESS,
    GET_NA_COURT_CONFIG_DATA_FAILURE,
    GET_NA_DEFAULT_COURT_CONFIG_DATA,
    GET_NA_DEFAULT_COURT_CONFIG_DATA_SUCCESS,
    GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE,
    UPDATE_NA_SHOW_CONFIG_MODAL,
    UPDATE_NA_FACILITIES_BASED_ON_CONFIG,
    UPDATE_NA_SELECTED_FACILITY,
    SAVE_NA_COURT_CONFIG_DATA,
    SAVE_NA_COURT_CONFIG_DATA_SUCCESS,
    SAVE_NA_COURT_CONFIG_DATA_FAILURE,
    UPDATE_NA_SIDE_BAR_DISPLAY_TYPE,
    UPDATE_NA_SIDE_BAR_STATUS_TYPE,
    CLEAR_NEXT_AVAILABLE_DATA,
    TOGGLE_NA_ADD_DRAWS_SIDE_PANEL,
    SAVE_NA_DRAWS_TO_SCHEDULE,
    SAVE_NA_DRAWS_TO_SCHEDULE_SUCCESS,
    SAVE_NA_DRAWS_TO_SCHEDULE_FAILURE,
    GET_NA_DRAWS_SCHEDULED,
    GET_NA_DRAWS_SCHEDULED_SUCCESS,
    GET_NA_DRAWS_SCHEDULED_FAILURE,
    GET_NA_NOT_ON_COURT_MATCHES,
    GET_NA_NOT_ON_COURT_MATCHES_SUCCESS,
    GET_NA_NOT_ON_COURT_MATCHES_FAILURE,
    UPDATE_NA_SUMMARY,
    GET_NA_ON_COURT_MATCHES,
    GET_NA_ON_COURT_MATCHES_SUCCESS,
    GET_NA_ON_COURT_MATCHES_FAILURE,
    CLEAR_NA_CONFIG_AND_FACILITY_SPECIFIC_DATA,
    UPDATE_NA_NOT_ON_COURT_MATCHES,
    UPDATE_NA_ON_COURT_MATCHES,
    SHOW_MATCH_STARTED_MODAL,
    NA_POST_SCORE,
    NA_POST_SCORE_SUCCESS,
    NA_POST_SCORE_FAILURE,
    SET_NA_ACTION_CONFIRM_POPUP_DATA,
    NA_POST_SCORE_CLEAR,
    NA_PUBLISH_DRAWS,
    NA_PUBLISH_DRAWS_SUCCESS,
    NA_PUBLISH_DRAWS_FAILURE,
    NA_CLEAR_PUBLISH_STATUS,
    CLEAR_NA_DRAWS_NOTIFICATIONS,
} from './actionTypes/next-available-types';
import {
    getActiveFacilitiesAndCourts,
    getFacilitiesAndCourtsToDisplay,
    dateFormatForDayConfig,
} from '../utils/courtSchedular';
import {
    compareMatches,
    ConfirmPopupTypes,
    DoNotShowMatchStarted,
    generateLocalStorageKey,
    getDrawStatusChangesToNotify,
    getModifiedDrawsListForAddedDraws,
    getUpdatedMatchObject,
    MatchSchedularStatusTypes,
    MatchStartOptions,
    MatchStatusOptions,
    MatchStatusTypes,
} from '../utils/nextAvailable';
import { createTypeByIdDict, updateCategoryTypesName } from '../utils/formatting';
import { showErrorPopup } from './notification-actions';

export const getDefaultConfigData = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: GET_NA_DEFAULT_COURT_CONFIG_DATA,
    });
    try {
        const response = await getDefaultNextAvailableConfig(mainApi, eventId);
        const { data, status } = response;
        if (status === 204) {
            dispatch({ type: GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE });
        } else {
            dispatch({
                type: GET_NA_DEFAULT_COURT_CONFIG_DATA_SUCCESS,
                payload: { courtConfig: data },
            });
        }
    } catch (error) {
        dispatch({ type: GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE });
    }
};

export const getNextAvailableConfigData = (eventId, selectedDate, clearData = true) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();

    dispatch({
        type: GET_NA_COURT_CONFIG_DATA,
        payload: { selectedDate },
    });

    if (clearData) {
        dispatch({
            type: CLEAR_NA_CONFIG_AND_FACILITY_SPECIFIC_DATA,
        });
    }

    let isConfigFetchFailed = false;
    try {
        const response = await getNextAvailableConfigForTheDay(mainApi, eventId, {
            date: moment.utc(selectedDate).format(dateFormatForDayConfig),
        });

        const { data, status } = response;
        if (status === 204) {
            isConfigFetchFailed = true;
            dispatch({ type: GET_NA_COURT_CONFIG_DATA_FAILURE });
        } else {
            dispatch({
                type: GET_NA_COURT_CONFIG_DATA_SUCCESS,
                payload: { courtConfig: data },
            });
        }
    } catch (error) {
        isConfigFetchFailed = true;
        dispatch({ type: GET_NA_COURT_CONFIG_DATA_FAILURE });
    }

    if (isConfigFetchFailed && !nextAvailable.defaultCourtConfig) {
        await dispatch(getDefaultConfigData(eventId));
    }

    await dispatch(checkAndUpdateSaveConfigViewDisplay());
    if (!isConfigFetchFailed) {
        await dispatch(updateFacilitiesListForConfigDay());
    }
};

export const updateFacilitiesListForConfigDay = () => async (dispatch, getState) => {
    const { drawEdit, nextAvailable } = getState();
    const { locations } = drawEdit;
    const { defaultCourtConfig, selectedDateCourtConfig, selectedFacilityId } = nextAvailable;

    const configToUse = selectedDateCourtConfig || defaultCourtConfig;
    const activeFacilitiesAndCourts = getActiveFacilitiesAndCourts(locations?.data || []);
    const facilitiesToDisplay = getFacilitiesAndCourtsToDisplay(activeFacilitiesAndCourts, configToUse);

    dispatch({
        type: UPDATE_NA_FACILITIES_BASED_ON_CONFIG,
        payload: {
            facilitiesAvailable: facilitiesToDisplay,
        },
    });

    const isSelectedFacilityInUpdatedFacilities = facilitiesToDisplay.find((fac) => fac.id === selectedFacilityId);
    if (!isSelectedFacilityInUpdatedFacilities) {
        const newSelectedFacilityId = facilitiesToDisplay?.length > 0 ? facilitiesToDisplay[0].id : '';
        await dispatch(setSelectedFacility(newSelectedFacilityId, facilitiesToDisplay));
    } else {
        await dispatch(setSelectedFacility(selectedFacilityId, facilitiesToDisplay));
    }
};

export const setSelectedFacility = (facilityId, facilitiesAvailable = []) => async (dispatch) => {
    const selectedFacility = facilitiesAvailable.find((facility) => facility.id === facilityId);

    let courtsOfSelectedFacility = [];
    if (selectedFacility) {
        courtsOfSelectedFacility = selectedFacility.courts.map((court) => {
            return {
                ...court,
                facilityId: selectedFacility.id,
                facilityName: selectedFacility.name,
                facilityAbbreviation: selectedFacility.abbreviation,
            };
        });
    }

    dispatch({
        type: UPDATE_NA_SELECTED_FACILITY,
        payload: {
            facilityId,
            courtsOfSelectedFacility,
        },
    });
};

export const updateSaveConfigViewDisplay = (show = false) => async (dispatch) => {
    dispatch({
        type: UPDATE_NA_SHOW_CONFIG_MODAL,
        payload: { showConfigModal: show },
    });
};

export const checkAndUpdateSaveConfigViewDisplay = () => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { selectedDate, selectedDateCourtConfig } = nextAvailable;

    const show = selectedDate && !selectedDateCourtConfig;
    dispatch(updateSaveConfigViewDisplay(show));
};

export const saveNextAvailableConfigData = (eventId, params) => async (dispatch, getState, { mainApi }) => {
    const {
        nextAvailable,
    } = getState();

    dispatch({ type: SAVE_NA_COURT_CONFIG_DATA });

    try {
        const response = await saveNextAvailableConfig(mainApi, eventId, params);

        dispatch({
            type: SAVE_NA_COURT_CONFIG_DATA_SUCCESS,
            payload: { courtConfig: response.data },
        });

        await dispatch(getNextAvailableConfigData(eventId, nextAvailable.selectedDate, false));
    } catch (error) {
        dispatch({ type: SAVE_NA_COURT_CONFIG_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error saving court config',
            error,
        }));
    }
};

export const setSidebarDisplayAndStatusTypes = (displayType, statusType) => async (dispatch) => {
    dispatch({
        type: UPDATE_NA_SIDE_BAR_DISPLAY_TYPE,
        payload: {
            displayType,
            statusType,
        },
    });
};

export const setSidebarStatusTypes = (statusType) => async (dispatch) => {
    dispatch({
        type: UPDATE_NA_SIDE_BAR_STATUS_TYPE,
        payload: {
            statusType,
        },
    });
};

export const clearNextAvailableData = () => async (dispatch) => {
    dispatch({
        type: CLEAR_NEXT_AVAILABLE_DATA,
    });
};

export const clearPostScoreErrors = () => async (dispatch) => {
    dispatch({ type: NA_POST_SCORE_CLEAR });
};

export const moveMatchInSidePanel = (matchId, sourceIndex, destinationIndex) => async (dispatch, getState) => {
    const { nextAvailable } = getState();

    const { notOnCourtMatches, sidebar } = nextAvailable;
    const { statusType } = sidebar;

    const statusMatches = [
        ...notOnCourtMatches[statusType],
    ];
    const [match] = statusMatches.splice(sourceIndex, 1); // Delete object at existing index
    statusMatches.splice(destinationIndex, 0, match); // Add object at new index

    dispatch({
        type: UPDATE_NA_NOT_ON_COURT_MATCHES,
        payload: {
            matches: {
                ...notOnCourtMatches,
                [statusType]: statusMatches,
            },
        },
    });
};

export const assignMatchToCourt = (eventId, matchId, sourceIndex, destinationCourtId) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable, auth } = getState();

    const { notOnCourtMatches, onCourtMatches, sidebar, selectedFacilityId, selectedDateCourtConfig } = nextAvailable;
    const { statusType } = sidebar;

    const statusMatches = [
        ...notOnCourtMatches[statusType],
    ];
    const [match] = statusMatches.splice(sourceIndex, 1); // Delete object at existing index

    const updatedMatch = {
        ...match,
        drawMatchStatus: MatchStatusTypes.ON_COURT,
        courtId: destinationCourtId,
    };
    onCourtMatches.push(updatedMatch);

    dispatch({
        type: UPDATE_NA_NOT_ON_COURT_MATCHES,
        payload: {
            matches: {
                ...notOnCourtMatches,
                [statusType]: statusMatches,
            },
        },
    });

    dispatch({
        type: UPDATE_NA_ON_COURT_MATCHES,
        payload: {
            matches: onCourtMatches,
        },
    });

    try {
        await scheduleMatch(mainApi, eventId, matchId, {
            courtId: destinationCourtId,
            dayConfigId: selectedDateCourtConfig.id,
            facilityId: selectedFacilityId,
            drawId: match.drawId,
        });

        const preferenceForNotShowingMatchPlacedPopup = localStorage.getItem(generateLocalStorageKey(DoNotShowMatchStarted, eventId, auth));

        if (selectedDateCourtConfig?.matchStartType === MatchStartOptions.PLACED_ON_COURT && !preferenceForNotShowingMatchPlacedPopup) {
            await dispatch({
                type: SHOW_MATCH_STARTED_MODAL,
                payload: {
                    show: true,
                    match: updatedMatch,
                },
            });
        }

        await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, false, true));
        await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(eventId, false));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error adding match to court',
            error,
        }));
        await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(eventId, true));
        await dispatch(getNotOnCourtMatchesConnectedToFacilityAndDayConfig(eventId));
    }
};

export const confirmActionFromConfirmPopup = () => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { actionConfirmPopup } = nextAvailable;

    if (actionConfirmPopup.type === ConfirmPopupTypes.RE_ASSIGN) {
        await dispatch(confirmMatchReAssignmentToCourt());
    } else if (actionConfirmPopup.type === ConfirmPopupTypes.REMOVE) {
        await dispatch(confirmMatchUnAssignmentFromCourt());
    }
};

export const declineActionFromConfirmPopup = () => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { actionConfirmPopup } = nextAvailable;

    if (actionConfirmPopup.type === ConfirmPopupTypes.RE_ASSIGN) {
        await dispatch(declineMatchReAssignmentToCourt());
    } else if (actionConfirmPopup.type === ConfirmPopupTypes.REMOVE) {
        await dispatch(declineMatchUnAssignmentFromCourt());
    }
};

export const confirmMatchUnAssignmentFromCourt = () => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig, actionConfirmPopup } = nextAvailable;

    await dispatch(setActionConfirmPopupData(false, null, null));
    try {
        await unScheduleMatch(mainApi, actionConfirmPopup.data.eventId, actionConfirmPopup.data.matchId, {
            dayConfigId: selectedDateCourtConfig.id,
            facilityId: selectedFacilityId,
            drawId: actionConfirmPopup.data.onCourtMatch.drawId,
        });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error removing match from court',
            error,
        }));
    }
    await dispatch(getDrawsConnectedToFacilityAndDayConfig(actionConfirmPopup.data.eventId, false, true));
    await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(actionConfirmPopup.data.eventId, false));
    await dispatch(getNotOnCourtMatchesConnectedToFacilityAndDayConfig(actionConfirmPopup.data.eventId));
};

export const declineMatchUnAssignmentFromCourt = () => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { actionConfirmPopup, onCourtMatches, notOnCourtMatches, sidebar } = nextAvailable;

    const updatedCourtMatches = [
        ...onCourtMatches,
        {
            ...actionConfirmPopup.data.onCourtMatch,
        },
    ];
    dispatch({
        type: UPDATE_NA_ON_COURT_MATCHES,
        payload: {
            matches: updatedCourtMatches,
        },
    });

    const updatedNotOnCourtMatched = {
        ...notOnCourtMatches,
    };
    updatedNotOnCourtMatched[sidebar.statusType].splice(actionConfirmPopup.data.destinationIndex, 1);
    dispatch({
        type: UPDATE_NA_NOT_ON_COURT_MATCHES,
        payload: {
            matches: updatedNotOnCourtMatched,
        },
    });

    await dispatch(setActionConfirmPopupData(false, null, null));
};

export const unAssignMatchFromCourt = (eventId, matchId, sourceCourtId, destinationIndex) => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { notOnCourtMatches, onCourtMatches, sidebar } = nextAvailable;
    const { statusType } = sidebar;

    const match = onCourtMatches.find((match) => match.courtId === sourceCourtId);
    dispatch({
        type: UPDATE_NA_ON_COURT_MATCHES,
        payload: {
            matches: onCourtMatches.filter((m) => m.courtId !== sourceCourtId),
        },
    });

    const statusMatches = [
        ...notOnCourtMatches[statusType],
    ];
    statusMatches.splice(destinationIndex, 0, {
        ...match,
        courtId: null,
        dateTimeStarted: null,
        dateTimeReStarted: null,
        drawMatchStatus: statusType,
        elaspsedTimeSeconds: null,
    });
    dispatch({
        type: UPDATE_NA_NOT_ON_COURT_MATCHES,
        payload: {
            matches: {
                ...notOnCourtMatches,
                [statusType]: statusMatches,
            },
        },
    });

    await dispatch(setActionConfirmPopupData(true, ConfirmPopupTypes.REMOVE, {
        eventId,
        matchId,
        sourceCourtId,
        destinationIndex,
        onCourtMatch: match,
    }));
};

export const confirmMatchReAssignmentToCourt = () => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { actionConfirmPopup, selectedFacilityId, selectedDateCourtConfig, onCourtMatches } = nextAvailable;

    const match = onCourtMatches.find((match) => match.id === actionConfirmPopup.data.matchId);

    await dispatch(setActionConfirmPopupData(false, null, null));
    try {
        await reScheduleMatch(mainApi, actionConfirmPopup.data.eventId, actionConfirmPopup.data.matchId, {
            dayConfigId: selectedDateCourtConfig.id,
            facilityId: selectedFacilityId,
            drawId: match.drawId,
            courtId: match.courtId,
        });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error re scheduling match onto different court',
            error,
        }));
    }
    await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(actionConfirmPopup.data.eventId, false));
};

export const declineMatchReAssignmentToCourt = () => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { actionConfirmPopup, onCourtMatches } = nextAvailable;

    const match = onCourtMatches.find((match) => match.id === actionConfirmPopup.data.matchId);
    const matches = onCourtMatches.filter((match) => match.id !== actionConfirmPopup.data.matchId);
    matches.push({
        ...match,
        courtId: actionConfirmPopup.data.sourceCourtId,
    });
    dispatch({
        type: UPDATE_NA_ON_COURT_MATCHES,
        payload: {
            matches,
        },
    });

    await dispatch(setActionConfirmPopupData(false, null, null));
};

export const reAssignMatchToCourt = (eventId, matchId, sourceCourtId, destinationCourtId) => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    const { onCourtMatches } = nextAvailable;

    const match = onCourtMatches.find((match) => match.courtId === sourceCourtId);
    const matches = onCourtMatches.filter((match) => match.courtId !== sourceCourtId);
    matches.push({
        ...match,
        courtId: destinationCourtId,
    });

    dispatch({
        type: UPDATE_NA_ON_COURT_MATCHES,
        payload: {
            matches,
        },
    });

    await dispatch(setActionConfirmPopupData(true, ConfirmPopupTypes.RE_ASSIGN, {
        eventId,
        matchId,
        sourceCourtId,
        destinationCourtId,
    }));
};

export const toggleAddDrawsSidePanel = () => async (dispatch, getState) => {
    const { nextAvailable } = getState();
    dispatch({
        type: TOGGLE_NA_ADD_DRAWS_SIDE_PANEL,
        payload: {
            showAddDivisionsSidePanel: !nextAvailable.showAddDrawsSidePanel,
        },
    });
};

export const clearDrawStatusChangesToNotify = () => async (dispatch) => {
    dispatch({
        type: CLEAR_NA_DRAWS_NOTIFICATIONS,
    });
};

export const getDrawsConnectedToFacilityAndDayConfig = (eventId, fetchMatches = false, checkAndNotifyStatus = false) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable, coreUI } = getState();
    const { selectedFacilityId, selectedDateCourtConfig, draws: previousDraws } = nextAvailable;
    const { drawCategoryTypes = [] } = coreUI.types?.tms?.draw || {};

    const drawCategoryTypesDict = updateCategoryTypesName(createTypeByIdDict(drawCategoryTypes));

    dispatch({ type: GET_NA_DRAWS_SCHEDULED });

    try {
        const response = await getDrawsForFacilityAndDay(mainApi, eventId, selectedDateCourtConfig.id, selectedFacilityId);
        const updatedDraws = getModifiedDrawsListForAddedDraws(response.data, drawCategoryTypesDict);
        const drawStatusChangesToNotify = checkAndNotifyStatus
            ? getDrawStatusChangesToNotify(previousDraws, updatedDraws)
            : {
                drawCompletedNotifications: [],
                drawReadyToStartNotifications: [],
                drawsToBeAutoFilledNotifications: [],
            };

        dispatch({
            type: GET_NA_DRAWS_SCHEDULED_SUCCESS,
            payload: {
                draws: updatedDraws,
                drawStatusChangesToNotify,
            },
        });

        if (fetchMatches) {
            await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(eventId, true));
            await dispatch(getNotOnCourtMatchesConnectedToFacilityAndDayConfig(eventId));
        }
    } catch (error) {
        dispatch({ type: GET_NA_DRAWS_SCHEDULED_FAILURE });
    }
};

export const addDrawsToFacilityAndDayConfig = (eventId, drawIds) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;

    dispatch({
        type: SAVE_NA_DRAWS_TO_SCHEDULE,
    });

    try {
        await addDrawsToFacilityAndDay(mainApi, eventId, selectedDateCourtConfig.id, selectedFacilityId, drawIds);
        dispatch({
            type: SAVE_NA_DRAWS_TO_SCHEDULE_SUCCESS,
        });

        await dispatch(toggleAddDrawsSidePanel());
        await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, true, true));
    } catch (error) {
        dispatch({
            type: SAVE_NA_DRAWS_TO_SCHEDULE_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error adding draws to the day',
            error,
        }));
    }
};

export const removeDrawFromFacilityAndDayConfig = (eventId, drawIds) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;
    dispatch({ type: 'SPLASH_SHOW_LOADING' });

    try {
        await removeDrawFromFacilityAndDay(mainApi, eventId, drawIds, selectedDateCourtConfig.id, selectedFacilityId);
        dispatch({ type: 'SPLASH_HIDE' });
        await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, true, true));
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error removing draw from the day',
            error,
        }));
    }
};

export const removeAllDrawsFromFacilityAndDayConfig = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;
    dispatch({ type: 'SPLASH_SHOW_LOADING' });

    try {
        await removeAllDrawsFromFacilityAndDay(mainApi, eventId, selectedDateCourtConfig.id, selectedFacilityId);
        dispatch({ type: 'SPLASH_HIDE' });
        await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, true));
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error removing all draws from the day',
            error,
        }));
    }
};

export const startDrawAddedToFacilityAndDayConfig = (eventId, drawIds, notifyPlayers = true) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;

    dispatch({ type: 'SPLASH_SHOW_LOADING' });

    try {
        await startDrawAddedToFacilityAndDay(mainApi, eventId, drawIds, notifyPlayers, selectedDateCourtConfig.id, selectedFacilityId);
        dispatch({ type: 'SPLASH_HIDE' });
        await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, true, true));
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error starting draw',
            error,
        }));
    }
};

export const getNotOnCourtMatchesConnectedToFacilityAndDayConfig = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable, coreUI } = getState();
    const { selectedFacilityId, selectedDateCourtConfig, draws } = nextAvailable;
    const { drawCategoryTypes = [] } = coreUI.types?.tms?.draw || {};

    const drawCategoryTypesDict = updateCategoryTypesName(createTypeByIdDict(drawCategoryTypes));

    dispatch({ type: GET_NA_NOT_ON_COURT_MATCHES });

    try {
        const response = await getMatchesForFacilityAndDay(
            mainApi,
            eventId,
            selectedDateCourtConfig.id,
            selectedFacilityId,
            [MatchStatusTypes.TODO, MatchStatusTypes.IN_QUEUE, MatchStatusTypes.DONE],
        );

        const matches = {};
        MatchStatusOptions.forEach((status) => {
            const matchesWithStatus = response.data
                .filter((match) => match.drawMatchStatus === status.id)
                .map((match) => getUpdatedMatchObject(match, draws, drawCategoryTypesDict))
                .sort(compareMatches(status));
            matches[status.id] = matchesWithStatus;
        });
        dispatch({
            type: GET_NA_NOT_ON_COURT_MATCHES_SUCCESS,
            payload: {
                matches,
            },
        });
    } catch (error) {
        dispatch({ type: GET_NA_NOT_ON_COURT_MATCHES_FAILURE });
    }
};

export const getOnCourtMatchesConnectedToFacilityAndDayConfig = (eventId, clearMatches = true) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable, coreUI } = getState();
    const { selectedFacilityId, selectedDateCourtConfig, draws } = nextAvailable;
    const { drawCategoryTypes = [] } = coreUI.types?.tms?.draw || {};
    const drawCategoryTypesDict = updateCategoryTypesName(createTypeByIdDict(drawCategoryTypes));

    const matchesToUpdate = clearMatches ? [] : nextAvailable.onCourtMatches;
    dispatch({
        type: GET_NA_ON_COURT_MATCHES,
        payload: {
            matches: matchesToUpdate,
        },
    });

    try {
        const response = await getMatchesForFacilityAndDay(
            mainApi,
            eventId,
            selectedDateCourtConfig.id,
            selectedFacilityId,
            [MatchStatusTypes.ON_COURT],
        );
        const onCourtMatches = response.data
            .map((match) => getUpdatedMatchObject(match, draws, drawCategoryTypesDict));
        dispatch({
            type: GET_NA_ON_COURT_MATCHES_SUCCESS,
            payload: {
                matches: onCourtMatches,
            },
        });
        await dispatch(getSummaryConnectedToFacilityAndDayConfig(eventId));
    } catch (error) {
        dispatch({ type: GET_NA_ON_COURT_MATCHES_FAILURE });
    }
};

export const getSummaryConnectedToFacilityAndDayConfig = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;

    try {
        const response = await getSummaryForFacilityAndDay(mainApi, eventId, selectedDateCourtConfig.id, selectedFacilityId);

        dispatch({
            type: UPDATE_NA_SUMMARY,
            payload: {
                summary: response.data,
            },
        });
    } catch (error) {
        // Do nothing
    }
};

export const clearMatchPlacedPopupShowStatus = () => async (dispatch) => {
    dispatch({
        type: SHOW_MATCH_STARTED_MODAL,
        payload: {
            show: false,
            match: null,
        },
    });
};

export const startAMatchOnCourt = (eventId, match) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable, auth } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;
    dispatch({ type: 'SPLASH_SHOW_LOADING' });

    try {
        await startMatch(mainApi, eventId, match.id, {
            dayConfigId: selectedDateCourtConfig.id,
            facilityId: selectedFacilityId,
            drawId: match.drawId,
            courtId: match.courtId,
        });
        dispatch({ type: 'SPLASH_HIDE' });

        const preferenceForNotShowingMatchPlacedPopup = localStorage.getItem(generateLocalStorageKey(DoNotShowMatchStarted, eventId, auth));
        if (selectedDateCourtConfig?.matchStartType !== MatchStartOptions.PLACED_ON_COURT &&
                match.schedulerStatus !== MatchSchedularStatusTypes.PAUSED &&
                !preferenceForNotShowingMatchPlacedPopup) {
            await dispatch({
                type: SHOW_MATCH_STARTED_MODAL,
                payload: {
                    show: true,
                    match,
                },
            });
        }
        await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(eventId, false));
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error scheduling match on court',
            error,
        }));
    }
};

export const pauseAMatchOnCourt = (eventId, match) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;
    dispatch({ type: 'SPLASH_SHOW_LOADING' });

    try {
        await pauseMatch(mainApi, eventId, match.id, {
            dayConfigId: selectedDateCourtConfig.id,
            facilityId: selectedFacilityId,
            drawId: match.drawId,
            courtId: match.courtId,
        });
        dispatch({ type: 'SPLASH_HIDE' });
        await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(eventId, false));
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error scheduling match on court',
            error,
        }));
    }
};

export const postScoreForAMatch = (eventId, matchId, requestBody) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: NA_POST_SCORE });
    try {
        const response = await postScore(mainApi, eventId, matchId, requestBody);
        if (response.error) {
            dispatch({
                type: NA_POST_SCORE_FAILURE,
                payload: response.error,
            });
        } else {
            dispatch({
                type: NA_POST_SCORE_SUCCESS,
            });

            await dispatch(getOnCourtMatchesConnectedToFacilityAndDayConfig(eventId, false));
            await dispatch(getNotOnCourtMatchesConnectedToFacilityAndDayConfig(eventId));
            await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, false, true));
        }
    } catch (error) {
        dispatch({
            type: NA_POST_SCORE_FAILURE,
            payload: error?.message,
        });
    }
};

export const setActionConfirmPopupData = (show = false, type = null, data = null) => async (dispatch) => {
    dispatch({
        type: SET_NA_ACTION_CONFIRM_POPUP_DATA,
        payload: {
            show,
            type,
            data,
        },
    });
};

export const publishDrawsForFacilityAndDayConfig = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { nextAvailable } = getState();
    const { selectedFacilityId, selectedDateCourtConfig } = nextAvailable;
    dispatch({ type: NA_PUBLISH_DRAWS });
    try {
        await publishDraws(mainApi, eventId, selectedDateCourtConfig?.id, selectedFacilityId);
        dispatch({
            type: NA_PUBLISH_DRAWS_SUCCESS,
        });
        await dispatch(getDrawsConnectedToFacilityAndDayConfig(eventId, false));
    } catch (error) {
        dispatch({
            type: NA_PUBLISH_DRAWS_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error publishing draws',
            error,
        }));
    }
};

export const clearPublishStatus = () => async (dispatch) => {
    dispatch({ type: NA_CLEAR_PUBLISH_STATUS });
};
